import { ENABLE_DIRECTORY_PAGE_SPEC } from '@utils/constants';
import { useExperiments } from '@wix/fe-essentials-standalone';

export function useIsDirectoryPageEnabled(): boolean {
  const { experiments } = useExperiments({ readOnly: true });
  return experiments.get(ENABLE_DIRECTORY_PAGE_SPEC) === 'B';
}
